type ConnectionStatus = "online" | "offline" | "sincronizando" | "erro";

interface ConnectionStatusBadgeProps {
  status: ConnectionStatus;
}

const statusConfig: Record<ConnectionStatus, { label: string; bg: string; dot: string; text: string }> = {
  online: { label: "Online", bg: "bg-[#CAF0D3]", dot: "bg-[#1B6E4F]", text: "text-[#1B6E4F]" },
  offline: { label: "Offline", bg: "bg-[#E8EAED]", dot: "bg-[#F57C00]", text: "text-[#F57C00]" },
  sincronizando: { label: "Sincronizando", bg: "bg-[#64B5F6]/20", dot: "bg-[#0052CC] animate-pulse", text: "text-[#0052CC]" },
  erro: { label: "Erro conexão", bg: "bg-[#FFCDD2]", dot: "bg-[#D32F2F]", text: "text-[#D32F2F]" },
};

export default function ConnectionStatusBadge({ status }: ConnectionStatusBadgeProps) {
  const cfg = statusConfig[status];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}